import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const RESET_DELAY = 1500;

async function fetchCart() {
  const response = await fetch(`${Theme.routes.cart_url}.js`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
  return response.json();
}

function sectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids.join(',');
}

async function addToCart(button) {
  const variantId = button.dataset.variantId;
  if (!variantId || button.disabled) return;

  const defaultLabel = button.dataset.defaultLabel || button.textContent.trim();
  button.disabled = true;
  button.textContent = 'Adding...';

  const deferred = CartLinesUpdateEvent.createPromise();

  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionIds(),
      }),
    });

    const result = await response.json();

    if (result.status) {
      button.dispatchEvent(
        new CartErrorEvent({ error: result.message || 'Add to cart failed', code: 'INVALID' })
      );
      const cart = await fetchCart();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: true, items: cart.items, source: 'trinsic-product-card' },
      });
      button.textContent = 'Error';
    } else {
      const cart = await fetchCart();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: false, items: cart.items, source: 'trinsic-product-card', sections: result.sections },
      });
      button.textContent = 'Added!';
    }
  } catch (error) {
    deferred.reject(error);
    button.dispatchEvent(
      new CartErrorEvent({ error: error?.message || 'Network error', code: 'SERVICE_UNAVAILABLE' })
    );
    button.textContent = 'Error';
  } finally {
    setTimeout(() => {
      button.disabled = false;
      button.textContent = defaultLabel;
    }, RESET_DELAY);
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target.closest('.trinsic-product-card__atc') : null;
  if (!target) return;
  event.preventDefault();
  addToCart(target);
});
